import amexUrl from "@/assets/wspayCards/AmericanExpress23.png";
import dinersUrl from "@/assets/wspayCards/Diners23.png";
import discoverUrl from "@/assets/wspayCards/discover23.png";
import maestroUrl from "@/assets/wspayCards/maestro23.png";
import mastercardUrl from "@/assets/wspayCards/MasterCard23.png";
import visaUrl from "@/assets/wspayCards/Visa23.png";
import wspayUrl from "@/assets/wspayCards/wsPayWebSecureLogo-118x50-transparent.png";
import { useMemo } from "react";
import "./CardLogos.scss";

const cardLinks = [
  {
    key: "wspay",
    title: "Monri WSpay - Web Secure Payment Gateway",
    href: "https://www.wspay.info",
    image: wspayUrl,
  },
  {
    key: "amex",
    title: "American Express",
    href: "#",
    image: amexUrl,
  },
  {
    key: "diners",
    title: "Diners Club International",
    href: "https://www.diners.com.hr",
    image: dinersUrl,
  },
  {
    key: "mastercard",
    title: "MasterCard",
    href: "https://www.mastercard.com/hr/",
    image: mastercardUrl,
  },
  {
    key: "maestro",
    title: "Maestro",
    href: "https://www.mastercard.com/hr/",
    image: maestroUrl,
  },
  {
    key: "visa",
    title: "Visa",
    href: "https://www.visa.com.hr/",
    image: visaUrl,
  },
  {
    key: "discover",
    title: "Discover",
    href: "https://www.discover.com/",
    image: discoverUrl,
  },
];

export const CardLogos = ({ cards }: { cards: string[] }) => {
  const filtered = useMemo(() => cardLinks.filter((card) => cards.includes(card.key)), [cards]);

  if (!filtered.length) return null;

  return (
    <div className="c-card-logos">
      {filtered.map((card) => (
        <a key={card.key} title={card.title} target="_blank" rel="noreferrer" href={card.href}>
          <img src={card.image} alt={card.title} />
        </a>
      ))}
    </div>
  );
};
